import { put, takeLatest } from 'redux-saga/effects';
import { Project, ProjectAPI } from 'api/project';
import { Task } from 'api/tasks';
import { FetchStatus, StoreActionProps } from 'data/core';
import { getProjectById, GetProjectPayload } from 'data/projects/actions';
import { saveTasks } from 'data/tasks/slice';
import { logger } from 'services';

function* getProjectByIdSaga({ payload }: StoreActionProps<GetProjectPayload>) {
  const {
    projectId,
    handleSuccess = () => {},
    handleError = () => {},
  } = payload;

  try {
    if (projectId) {
      const project: Project = yield ProjectAPI.getProjectDetails(projectId);

      const phases = project.projectPhases;
      let tasks: Task[] = [];

      phases.map((p) => {
        tasks = [...tasks, ...p.tasks];

        return p;
      });

      yield put(saveTasks({ data: tasks, fetchStatus: FetchStatus.Partial }));

      handleSuccess();
    } else {
      throw new Error('Project ID not found');
    }
  } catch (error) {
    logger.error('getProjectDetails failed', { error });

    handleError();
  }
}

export const watchGetProjectByIdSaga = function* (): Generator {
  yield takeLatest(getProjectById.type, getProjectByIdSaga);
};
